import React from 'react'
import { Badge } from 'reactstrap'
import { Link } from 'react-router-dom'

/*
  <SetsListItem 
    name={val.name} 
    id={val.id} 
    key={'SetsListItem' + val.id} 
    activeSet={props.activeSet}
    handleDeleteSet={props.handleDeleteSet}
  />
*/

export default function SetsListItem (props) {
  return (
    <tr className={props.id === props.activeSet ? 'bg-info m2selected-node' : null}>
      <td>
        <Link to={`/content/sets/${props.id}${props.locationSearch}`}>{props.name}</Link>
      </td>
      <td>
        <Badge 
          color='danger' 
          onClick={() => props.handleDeleteSet(props.id)}
          className='m2clickable'  
        >
          Delete
        </Badge>
      </td>
    </tr>
  )
}


// WEBPACK FOOTER //
// ./src/components/Content/ManageSetsComponents/SetsListItem.js